import React from "react";
import { SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Wrapper, FirstContentWrapper, StyledImage, StyledSwiper, OverlayContainer, OverlayText, OverlayTextDescription, SegmentButton } from "./firstContent.styles";
import mainImage from "../../Assets/Images/optimized/mainImage1-hero.webp";
import secondImage from "../../Assets/Images/optimized/mainImage2-hero.webp";

const FirstContent = () => {
  const slides = [
    {
      image: mainImage,
      title: "Machinery for Every Task",
      description: "Your mission, our machinery. Dependable plant support for projects of every size.",
      ctaText: "About us",
      ctaHref: "/about",
    },
    {
      image: secondImage,
      title: "On the Move for Your Project",
      description: "From first ground break to final clearance, we keep your schedule moving.",
      ctaText: "Plant Hire",
      ctaHref: null,
    },
  ];

  return (
    <Wrapper>
      <FirstContentWrapper>
        <StyledSwiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          loop={true}
          autoplay={{
            delay: 9000,
            disableOnInteraction: false,
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <OverlayContainer>
                <StyledImage src={slide.image} alt={slide.title} loading={index === 0 ? "eager" : "lazy"} fetchPriority={index === 0 ? "high" : "auto"} decoding="async" />
                <div className="textContentWrapper">
                  <OverlayText>{slide.title}</OverlayText>
                  <OverlayTextDescription>{slide.description}</OverlayTextDescription>
                  {slide.ctaText && (
                    <SegmentButton
                      href={slide.ctaHref || "#"}
                      onClick={(e) => {
                        if (!slide.ctaHref) e.preventDefault();
                      }}
                    >
                      {slide.ctaText}
                    </SegmentButton>
                  )}
                </div>
              </OverlayContainer>
            </SwiperSlide>
          ))}
        </StyledSwiper>
      </FirstContentWrapper>
    </Wrapper>
  );
};

export default FirstContent;
